<template>
  <div class="contact min-h-50 text-NotoSansRegular tracking-wider">
    <div class="border borderColordarkgray2 rounded overflow-hidden">
      <div class="service">
        <div class="contact-body px-4 md:px-10 py-6 md:py-8">
          <h4 class="mb-4 font-bold">客服信箱</h4>
          <h5 >若對LiveABC有任何建議或問題，請以下列方式與我們聯繫，我們會盡速回覆您，非常感謝。</h5>
          <div class="mt-4">
            <p>客服專線：02-2578-7838</p>
            <p>客服信箱：<a class="underline" href="mailto:service@liveabc.com">service@liveabc.com</a></p>
            <p class="flex">LINE客服：<a class="underline flex items-center px-3 md:px-0"
              href="https://lin.ee/wfB4HKN" target="_blank">點此加入</a></p>
            <p>服務時間：週一至週五 8:30-17:30</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Connect',
  metaInfo () {
    return {
      title: '客服信箱',
      titleTemplate: null
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .contact-body {
    min-height: 26em;
    @media (max-width: 1025px) {
      min-height: 20em;
    }
    @media (max-width: 769px) {
      min-height: 18em;
    }
    @media (max-width: 577px) {
      min-height: 16em;
    }
  }

</style>
